import { PropsWithChildren, useRef, useCallback } from "react"
import { SnackbarProvider as MuiSnackbarProvider, SnackbarKey } from "notistack"
import { IconButton } from "@mui/material"
import CloseIcon from "@mui/icons-material/Close"

const ToastifyProvider = ({ children }: PropsWithChildren<unknown>) => {
  const notistackRef = useRef<MuiSnackbarProvider>(null)
  const onClickDismiss = useCallback(
    (key: SnackbarKey) => () => {
      notistackRef.current?.closeSnackbar(key)
    },
    [notistackRef]
  )
  return (
    <MuiSnackbarProvider
      maxSnack={3}
      anchorOrigin={{ horizontal: "center", vertical: "top" }}
      hideIconVariant
      ref={notistackRef}
      action={key => (
        <IconButton onClick={onClickDismiss(key)}>
          <CloseIcon sx={{ color: "white", bgcolor: "transparent" }} />
        </IconButton>
      )}
    >
      {children}
    </MuiSnackbarProvider>
  )
}

export default ToastifyProvider
